import { render, staticRenderFns } from "./deductrecord.vue?vue&type=template&id=3687faf4&scoped=true&"
import script from "./deductrecord.vue?vue&type=script&lang=js&"
export * from "./deductrecord.vue?vue&type=script&lang=js&"
import style0 from "./deductrecord.vue?vue&type=style&index=0&id=3687faf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3687faf4",
  null
  
)

export default component.exports